import styled, { css } from 'styled-components';

import Theme from 'Theme';
import Card from 'components/common/Card';
import { fadeIn } from 'components/Animations';
import TextInput from 'components/TextInput';

export const MarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const UploadContain = styled.div`
  padding-bottom: 16px;
  max-width: 50%;
`;

export const InnerContainer = styled.div`
  flex: 1;
  max-width: 1600px;
  margin-top: calc(88px + 24px);

  ${(props) => props.theme.media.sm.max`
    width: 100%;
    margin-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  `}

  ${(props) => props.theme.media.xl.max`
    max-width: 1366px;
    margin-top: calc(88px + 16px);
  `}

  ${(props) => props.theme.media.sm.min`
    padding-left: 16px;
    padding-right: 16px;
  `}

  ${(props) => props.theme.media.lg.max`
    max-width: 1024px;
  `}
`;

export const OrderContain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: calc(100% - 88px);

  ${(props) => props.theme.media.sm.max`
    overflow: auto;
  `}
`;

export const Padding = styled.div`
  padding: 16px;
`;

export const Chip = styled.div`
  display: inline-flex;
  text-align: center;
  justify-content: center;
  width: 120px;
  padding: 12px;
  border-radius: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => props.color};
  will-change: opacity, transform;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.5;
    transform: scale(1.05, 1.05);
  }
`;

export const ScrollContain = styled.div`
  max-height: 450px;
  overflow: auto;
  margin-top: 16px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(131, 157, 174, 0.2);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgb(122, 141, 153, 0.8);
    border-radius: 4px;
  }
`;

export const ButtonContain = styled.div`
  display: flex;
  margin-left: 16px;
`;

export const Link = styled.a`
  text-decoration: none;
  color: unset;
`;

export const DetailSection = styled.div`
  flex: 1;
`;

export const DetailsContain = styled.div`
  font-family: 'Roboto';
  display: flex;
  margin-top: 16px
  line-height: 1.3em;

  ${(props) => props.theme.media.sm.max`
    flex-direction: column;
  `}
`;

export const Text = styled.div`
  font-size: ${(props) => (props.large ? '2em' : '1em')};
  margin-bottom: 0px;
  font-family: 'Roboto';
  color: ${(props) => props.color || props.theme.brandColor};
`;

export const SubText = styled.div`
  font-family: 'Roboto';
  line-height: 1.5em;
  font-size: 0.875em;
  color: ${(props) => props.theme.mediumGrey};
`;

export const EmptyText = styled.div`
  font-family: 'Roboto';
  font-size: 1.2em;
  line-height: 1.2em;
  text-align: center;
  font-weight: 300;
  color: #c7c7c7;
  padding: 24px;
`;

export const InnerContain = styled.div`
  ${(props) => props.theme.media.sm.max`
    padding-bottom: 64px;
  `}
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AssessContain = styled.div`
  margin-bottom: 24px;
`;

// ----- OrderDocument ---- //

export const Description = styled.div`
  font-size: 11pt;
  font-weight: bold;
`;

export const Filename = styled.div`
  font-size: 9pt;
  color: grey;
`;

export const Subtitle = styled.div`
  font-size: 9pt;
  color: ${Theme.secondaryColor};
`;

export const ItemContain = styled.div`
  transition: transform 0.2s ease;
  padding: 1em;
  ${fadeIn}
`;

export const FlexContain = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.justify &&
    `
    justify-content: ${props.justify} !important;
  `}
`;

export const IconOffset = styled.div`
  position: relative;
  top: 4px;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

export const PrimaryLine = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 1.5em;
  color: rgb(1, 52, 83);
  font-family: ${Theme.primaryFont};
`;

export const SecondaryLine = styled.div`
  font-size: 16px;
  line-height: 1.5em;
  font-weight: ${(props) => props.fontWeight || 400};
  color: grey;
  font-family: ${Theme.primaryFont};
`;

export const Cancel = styled.div`
  cursor: pointer;

  i {
    transition: all 250ms ease-in-out;
    -webkit-transition: all 250ms ease-in-out;
  }

  &:hover i {
    color: ${Theme.dangerColor} !important;
  }
`;

export const MarginTop = styled.div`
  margin-top: 24px;
`;

// ------ Order Item ----- //

export const CertFlex = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const ChipsContain = styled(Flex)`
  justify-content: flex-end;
  right: 16px;
  flex: 1;
`;

export const PriceContain = styled.div`
  margin-right: 16px;
`;

export const TextContain = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  font-family: roboto;
  display: flex;
  font-size: 1.2em;
  align-items: center;
  font-weight: 500;
  margin: 0px;

  ${({ isUrgent, success }) => css`
    color: ${success
      ? Theme.successColor
      : isUrgent
      ? Theme.dangerColor
      : Theme.brandColor};
  `};
`;

export const PriceText = styled.div`
  margin: 0px;
  display: flex;
  font-size: 1.5em;
  font-family: roboto;
  align-items: center;
  color: ${Theme.successColor};
`;

export const InnerFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CertSubtitle = styled.div`
  font-size: 16px;
  line-height: 2em;
  font-weight: unset;
  color: grey;
  font-weight: 300;
  font-family: roboto, sans-serif;
`;

export const Slide = styled.div`
  flex: 1;
  cursor: pointer;
  border-radius: 3px;
  transition: all 250ms ease-in-out;
  -webkit-transition: all 250ms ease-in-out;

  box-shadow: 0px 0px 0px 1px #d6d8d963;
`;

export const FlexCol = styled.div`
  flex: 1;
  display: flex;
  margin-right: 8px;
  flex-direction: column;
`;

export const OrderCard = styled(Card.Content)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 0.5em;
  min-height: calc(80px - 32px);

  box-shadow: 0px 2px 0px 0px #495e6a30;
`;

export const SummaryLabel = styled.div`
  font-family: 'Roboto';
  background-color: #f4f4f4;
  padding: 0.4em 0.8em;
  border-radius: 2px;
  color: #495e6a;
  margin-right: 0.5em;
  font-size: 0.8em;
`;

export const AddressText = styled.h3`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 1.2em;
  color: rgb(1, 52, 83);
  margin: 0px;
`;

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  align-items: center;
`;

export const CardText = styled.p`
  font-family: 'Roboto';
  line-height: 1em;
  color: #333;
  font-weight: 300;
`;

export const CardContainer = styled.div`
  margin-bottom: 0.5em;
`;

export const AssessmentNumber = styled.p`
  font-size: 1.2em;
  font-weight: 500;
  margin: 0px;
  margin-top: 0.8em;
  font-family: 'Roboto';
  color: ${(props) => props.theme.successColor};
`;

export const FlexItem = styled.div`
  flex: 1;

  padding-left: 0.5em;
  padding-right: 0.5em;
`;

export const CardFlexContain = styled.div`
  display: flex;
`;

export const CardMarginBottom = styled(Card.Content)`
  margin-bottom: 0.5em;
`;

export const FlexEnd = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const Button = styled.div`
  display: flex;
  flex: 1;
  color: #fff;
  padding: 0em 1em;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  line-height: 2.6em;
  justify-content: center;
  align-items: center;
  font-family: 'Roboto';
  background-color: ${(props) => props.theme.brandColor};
  max-width: ${props => props.fullWidth ? 'unset' : '120px'};

  ${(props) =>
    props.disabled &&
    `
    color: #a4a4a4;
    background-color: #e5e5e5;
  `}

  ${(props) =>
    props.secondary &&
    `
    background-color: #fff;
    color: rgb(20, 76, 110);
    box-shadow: inset 0px 0px 0px 2px rgb(20, 76, 110);
  `}

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;

export const ButtonLabel = styled.span`
  margin-left: 0.5em;
`;

export const StatusChipStyled = styled.div`
  flex: 1;
  display: flex;
  border-radius: 2px;
  max-width: 11em;
  height: 2.6em;
  font-size: 0.75em;
  box-shadow: 0px 0px 0px 1px ${(props) => props.color};

  align-items: center;
  justify-content: center;

  will-change: opacity, transform;
  transition: all 0.2s ease-in-out;

  line-height: 1.2em;
  color: ${(props) => props.color};
  font-family: roboto, sans-serif;
`;

export const Bold = styled.span`
  font-weight: 500;
  margin-right: 0.5em;
`;

export const LoadingContain = styled.div`
  display: flex;
  font-family: 'Roboto';
  font-size: 1.1em;
  line-height: 2em;
  color: ${(props) => props.theme.brandColor};
  margin-top: 0.5em;
  margin-bottom: 01em;
  font-weight: 500;
`;

export const CardTitle = styled(Card.Title)`
  margin-bottom: 0.5em;
  background-color: #495e6a0a;
  font-size: 1.2em;
  padding: 0.4em 0.5em;
  color: #18242a;
  border-radius: 2px;
  font-weight: 400;
  box-shadow: 0px 0px 0px 1px #ebeeeec4;
  height: 24px;

  background: #ffffff; /* Old browsers */
  background: -moz-linear-gradient(top, #ffffff 0%, #f9fafa 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    #ffffff 0%,
    #f9fafa 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #f9fafa 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f9fafa',GradientType=0 ); /* IE6-9 */
`;

export const NotesContain = styled.div`
  padding: 0.8em;
  margin-top: 1em;
  border-radius: 4px;
  background-color: #fafbfb;
  box-shadow: inset 0px 0px 0px 1px #f0f2f2;
`;

export const FileFlexContain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const NotesInput = styled(TextInput)`
  flex: 1;
  margin-right: 8px;
  margin-bottom: 0px;
`;

export const TextInputFull = styled(TextInput)`
  flex: 1;
`;

export const ButtonLink = styled.a`
  margin-left: 8px;
  background: none;
  border: none;
  text-decoration: underline;
  font-size: 1em;
  font-weight: 400;
  font-family: Roboto;
  color: rgb(0, 118, 190);
  cursor: pointer;
`;

export const SecondaryText = styled.p`
  font-family: 'Roboto';
  background-color: #6a7a8517;
  padding: 0.4em 0.6em;
  border-radius: 2px;
  color: #495e6a;
  margin: 0px;
  font-size: 0.8em;
  display: inline-block;
  margin-top: 4px;
`;

export const StepInformation = styled.p`
  font-family: 'Roboto';
  line-height: 2em;
  color: #333;
  margin-top: 0.5em;
  margin-bottom: 01em;
  font-weight: 300;
`;

export const ETANote = styled.span`
  font-weight: 400;
  color: #144c6e;
  font-size: 0.875em;
  word-break: break-word;
  margin-right: 0.5em;
  background-color: #0076be1c;
  padding: 0.2em 0.5em;
  border-radius: 4px;
`;
